import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Messages = lazy(() => import("@/pages/Messages"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/messages")({
  component: () => (
    <ProtectedRoute>
      <Messages />
    </ProtectedRoute>
  ),
});
